// extracted by mini-css-extract-plugin
export default {"scoreBlock":"saXjhPqcpKZ7Hyu1KydR"};